import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IFlag } from '@benefitsui/app/api/benefits-clients';

@Injectable({
  providedIn: 'root'
})
export class FlagsService {
  private flags: Record<string, BehaviorSubject<boolean>> = {};

  private get debugOverrides(): Record<string, boolean> {
    // TODO : support flag overrides again
    return {};
  }

  updateFlags(newFlags: IFlag[]): void {
    newFlags.forEach(({ name, enabled }) => {
      if (!name) return;
      const override = this.debugOverrides[name];
      const newFlagValue = override === undefined ? enabled : override;
      const subject = this.flags[name];
      if (subject) {
        subject.next(newFlagValue);
      } else {
        this.flags[name] = new BehaviorSubject(newFlagValue);
      }
    });
  }

  /**
   *
   * @param name name of the flag to subscribe to
   */
  subscribeToFlag(name: string): BehaviorSubject<boolean> {
    let observable = this.flags[name];
    if (!observable) {
      const newFlagValue = this.debugOverrides[name];
      this.flags[name] = new BehaviorSubject<boolean>(newFlagValue);
      observable = this.flags[name];
    }

    return observable;
  }

  /**
   * Observe mutliple flag names, returning an array of observables
   *
   * @param names names of flags to observe
   */
  observeFlags(names: string[]): Observable<boolean>[] {
    return names.map((name) => this.subscribeToFlag(name));
  }
}
